import styled, { css } from 'styled-components';

interface IContainerProps {
  error?: string;
  height?: number;
}

export const Container = styled.label<IContainerProps>`
  margin-bottom: 0.9375rem;
  display: block;
  position: relative;

  textarea {
    background-color: #fff;
    border: 1px solid
      ${({ error, theme }) => (error ? theme.colors.danger.color : theme.colors.border)};
    background-color: ${({ theme }) => theme.colors.white};
    box-sizing: border-box;
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 1rem 0.9375rem;

    height: ${({ height }) => height || 17.25}rem;
    width: 100%;

    transition: all 150ms ease;

    &:hover {
      border: 1px solid hsl(0, 0%, 70%);
    }

    &::placeholder {
      font-family: 'Inter', sans-serif;
    }

    &:active,
    :focus {
      border: 1px solid hsl(0, 0%, 70%);
      box-shadow: none;
    }

    @media (max-width: 991px) {
      font-size: 1rem;
      padding: 1.5625rem 0.9375rem;
    }
  }
  .helperText {
    font-weight: 300;
    font-size: 0.75rem;
    line-height: 1.5rem;
    padding: 0.5rem 0 0;
  }
`;

export const Error = styled.span`
  color: ${({ theme }) => theme.colors.danger.color} !important;
  font-size: 0.75rem !important;
  padding: 0.3125rem;
  display: block;
`;

export const Label = styled.span`
  font-style: normal;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.texts};
  display: flex;
`;

interface IPasswordIconContainerType {
  hasLabel: boolean;
}
export const PasswordIconContainer = styled.button<IPasswordIconContainerType>`
  position: absolute;
  right: 0;
  top: 0;
  min-width: 1px !important;
  z-index: 10;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 1.25rem;

  svg {
    color: ${({ theme }) => theme.colors.primary.color};
    width: 0.9375rem !important;

    ${({ hasLabel }) =>
      hasLabel &&
      css`
        margin-top: 1.25rem;
      `}
  }
`;

export const IconContainer = styled.div`
  position: relative;

  & > div {
    position: absolute;
    z-index: 10;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 1.25rem;

    svg {
      color: ${({ theme }) => theme.colors.primary.color};
      width: 0.9375rem !important;
    }
  }

  input {
    padding-left: 3.125rem;
  }
`;

interface IMaxCharsContainer {
  reachedMaxChars: boolean;
}
export const MaxCharsContainer = styled.p<IMaxCharsContainer>`
  text-align: right;

  ${({ reachedMaxChars }) =>
    reachedMaxChars &&
    css`
      font-weight: bold;
      color: ${({ theme }) => theme.colors.danger.color};
    `}
`;
